var index = {
   namespaced: true,
   state: {
      rates: null,
      ratesLoading: false,
      ratesError: {
         message: null,
         code: null,
      },
   },
   mutations: {
      setRates(state, rates) {
         state.rates = rates;
      },
   },
   actions: {
      async loadRates(context) {
         const { commit } = context;
         const { appDataPath } = context.rootState.theme.theme;

         // console.log(
         //    "loadRates - context",
         //    context,
         //    context.rootState.theme.theme
         // );

         this.loadedCopy = await fetch(`${appDataPath}/mortgage-rates.json`, {
            method: "GET", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, cors, *same-origin
            // cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
               "Content-Type": "application/json",
            },
            redirect: "follow", // manual, *follow, error
            referrer: "no-referrer", // no-referrer, *client
         })
            .then((response) => {
               if (response.status === 404) {
                  console.log("404 RETURNED~~~~~~~~~~");
                  throw new Error("404");
               }

               return response.json();
            })
            .then((response) => {
               // Simulate a slow service call
               // setTimeout(() => {
               commit("setRates", response);
               // }, 1000);
            })
            .catch((err) => {
               console.log("error loading rates", err.message, err.stack);
            });
      },
   },
};

export default index;
